import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _EmployeeDiscountType } from '../../../../core/services/dataBean/EntityCatalog';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";

}

export const SelectEmployeeDiscountType = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_EmployeeDiscountType);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDType === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDType,
                    label: found.DataBeanProperties.Name,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const getLista = () => {
        instance.getEmployeeDiscountTypeCatalog().then((resp: any) => {
            if (resp) {
                setLista(resp);
            }
        }).catch(
            err => { console.error(err) }
        );
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDType,
        label: item.DataBeanProperties.Name,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Descuento"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Descuento..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
